import { createAction, createAsyncThunk } from "@reduxjs/toolkit";

import { ApiService } from "../../service/ApiService";

export const getPageContent = createAsyncThunk(
  "content/getPageContent",
  async ({ tag, languageCode }, { rejectWithValue }) => {
    try {
      if (!languageCode || !tag) {
        return;
      }

      const { data } = await ApiService.getPageContent(tag, languageCode);

      return { data, languageCode, tag };
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const getAllCountries = createAsyncThunk(
  "content/getAllCountries",
  async (languageCode, { rejectWithValue }) => {
    try {
      if (!languageCode) return;

      const { data } = await ApiService.getAllCountries(languageCode);

      return { data, languageCode };
    } catch (e) {
      rejectWithValue(e.response.data.error);
    }
  },
);

export const getCountryInfo = createAsyncThunk(
  "content/getCountryInfo",
  async ({ countryTag, languageCode }, { rejectWithValue }) => {
    try {
      const { data } = await ApiService.getCountryInfo(
        countryTag,
        languageCode,
      );

      return data;
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const getProxiesMenu = createAsyncThunk(
  "content/getProxiesMenu",
  async (languageCode, { rejectWithValue }) => {
    try {
      if (!languageCode) return;

      const { data } = await ApiService.getMenuProxy(languageCode);

      return { data, languageCode };
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const getHTMLCode = createAsyncThunk(
  "content/getHTMLSomeCode",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ApiService.getHTMLCode();
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);

export const serverSeoSave = createAction("content/serverSeoSave");
export const serverCountrySave = createAction("content/serverCountrySave");
export const saveCountryInfo = createAction("content/saveCountryInfo");
export const serverMenuProxySave = createAction("content/saveMenuProxy");
